module.exports = __webpack_public_path__ + "static/img/hh_gif.3fd89656.gif";